import type { OrderItemProfileNode, PurchasedItemProfileNode } from '@snowit/models';
import type { UserProfileModel } from '@snowit/types/users';

export const mapItemProfileToUserProfile = (input: PurchasedItemProfileNode): UserProfileModel => {
  return {
    name: input.name,
    sex: input.sex,
    skibootsSize: input.skibootsSize,
    surname: input.surname,
    types: input.types ?? [],
    uid: input.uid,
    age: input.age,
    anonymousProfile: input.anonymousProfile,
    birthday: input.birthday,
    city: input.city,
    countryCode: input.countryCode,
    createdAt: undefined,
    documentBackURL: input.documentBackURL,
    documentFrontURL: input.documentFrontURL,
    documentPhotoURL: input.documentPhotoURL,
    fisiNumber: input.fisiNumber,
    height: input.height,
    leader: input.leader,
    level: input.level,
    maestriNumber: input.maestriNumber,
    phone: input.phone,
    room: input.room,
    state: input.state,
    street: input.street,
    updatedAt: undefined,
    weight: input.weight,
    cf: input.cf,
  };
};

export const mapOrderItemProfile = (input: OrderItemProfileNode): UserProfileModel => {
  return {
    name: input.name,
    sex: input.sex,
    skibootsSize: input.skibootsSize,
    surname: input.surname,
    types: input.types ?? [],
    uid: input.uid,
    age: input.age,
    anonymousProfile: input.anonymousProfile,
    birthday: input.birthday,
    city: input.city,
    countryCode: input.countryCode,
    createdAt: undefined,
    documentBackURL: input.documentBackURL,
    documentFrontURL: input.documentFrontURL,
    documentPhotoURL: input.documentPhotoURL,
    fisiNumber: input.fisiNumber,
    height: input.height,
    leader: input.leader,
    level: input.level,
    maestriNumber: input.maestriNumber,
    phone: input.phone,
    room: input.room,
    state: input.state,
    street: input.street,
    updatedAt: undefined,
    weight: input.weight,
    cf: input.cf,
  };
};
